// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".dbfa930e1db3374b391d5e52f5e1b2f4.js";
};